// 各站可被搜尋引擎收錄的獨立內容頁：canonical 指向頁面自身正式網址（不帶 query、fragment）
// 不在清單內的頁面不輸出 canonical；回首頁的 fallback 路徑（konibet-nodeposit-bonus、katsuwin-2、bons-nodeposit-bonus）
// 刻意不列入，待保留／轉址／退役決策後再處理
const canonicalConfig = {
  theme_gold: {
    origin: 'https://www.katsuwin.ai',
    paths: [
      '/',
      // 資訊頁
      '/page/sup-faq',
      '/page/sup-how-to-register',
      '/page/sup-how-to-login',
      '/page/sup-self-restraint',
      '/page/sup-responsible-gaming',
      '/page/sup-verify-your-account',
      '/page/sup-account-binding',
      '/page/sup-payment-method',
      '/page/sup-vip-class-upgrading',
      '/page/sup-wallet',
      '/page/agent',
      '/page/cookie-policy',
      '/page/privacy',
      '/page/rule',
      '/page/sports-rule',
      '/page/terms',
      // 存提款／卡片設定／客服教學頁
      '/page/support',
      '/page/sup-deposit-bank',
      '/page/sup-deposit-crypto',
      '/page/sup-deposit-jeten',
      '/page/sup-deposit-mtpay',
      '/page/sup-deposit-usdt',
      '/page/sup-deposit-vega',
      '/page/sup-withdraw-bank',
      '/page/sup-withdraw-crypto',
      '/page/sup-withdraw-jeton',
      '/page/sup-withdraw-mtpay',
      '/page/sup-withdraw-vega',
      '/page/sup-cardsetting-bank',
      '/page/sup-cardsetting-ewallet',
      '/page/sup-cardsetting-ewalletid',
      // 遊戲分類頁（首頁 :seo_path）
      '/KatsuPromo',
      '/Relax-Play',
      '/Sports',
      '/classic-favorites',
      '/live-casino',
      '/new-game',
      '/pachinko-pachislot',
      '/popular-games',
      '/roulette',
      '/thrill-picks'
    ]
  }
}

const config = canonicalConfig[process.env.VUE_APP_THEME]
const canonicalPaths = new Set(config ? config.paths : [])

// 依路由路徑更新 <link rel="canonical">，確保頁面上最多一個
export function updateCanonical(path) {
  document.querySelectorAll('link[rel="canonical"]').forEach(link => link.remove())

  // /page/sup-faq/ 與 /page/sup-faq 視為同一頁
  const normalizedPath = path.length > 1 ? path.replace(/\/+$/, '') : path
  if (!config || !canonicalPaths.has(normalizedPath)) return

  const link = document.createElement('link')
  link.rel = 'canonical'
  link.href = config.origin + (normalizedPath === '/' ? '/' : normalizedPath)
  document.head.appendChild(link)
}
